// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__73GfN","rightAdornment":"Header_rightAdornment__1MPIm"};